"use client";
var m = Object.defineProperty;
var I = (t, e, s) => e in t ? m(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var n = (t, e, s) => I(t, typeof e != "symbol" ? e + "" : e, s);
import * as S from "react-dom";
import { a as A } from "./useRenderElement-B8V3_e8R.mjs";
import { u as g } from "./useOnMount-JHtE6teb.mjs";
import { u as b } from "./useEventCallback-CjuAhyNz.mjs";
let d = /* @__PURE__ */ function(t) {
  return t.startingStyle = "data-starting-style", t.endingStyle = "data-ending-style", t;
}({});
const k = {
  [d.startingStyle]: ""
}, p = {
  [d.endingStyle]: ""
}, x = {
  transitionStatus(t) {
    return t === "starting" ? k : t === "ending" ? p : null;
  }
}, a = null;
let h = globalThis.requestAnimationFrame;
class q {
  constructor() {
    /* This implementation uses an array as a backing data-structure for frame callbacks.
     * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
     * never calls the native `cancelAnimationFrame` if there are no frames left. This can
     * be much more efficient if there is a call pattern that alterns as
     * "request-cancel-request-cancel-…".
     * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
     * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
    n(this, "callbacks", []);
    n(this, "callbacksCount", 0);
    n(this, "nextId", 1);
    n(this, "startId", 1);
    n(this, "isScheduled", !1);
    n(this, "tick", (e) => {
      var c;
      this.isScheduled = !1;
      const s = this.callbacks, r = this.callbacksCount;
      if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, r > 0)
        for (let i = 0; i < s.length; i += 1)
          (c = s[i]) == null || c.call(s, e);
    });
  }
  request(e) {
    const s = this.nextId;
    this.nextId += 1, this.callbacks.push(e), this.callbacksCount += 1;
    const r = process.env.NODE_ENV === "test" && h !== requestAnimationFrame && (h = requestAnimationFrame, !0);
    return (!this.isScheduled || r) && (requestAnimationFrame(this.tick), this.isScheduled = !0), s;
  }
  cancel(e) {
    const s = e - this.startId;
    s < 0 || s >= this.callbacks.length || (this.callbacks[s] = null, this.callbacksCount -= 1);
  }
}
const l = new q();
class u {
  constructor() {
    n(this, "currentId", a);
    n(this, "cancel", () => {
      this.currentId !== a && (l.cancel(this.currentId), this.currentId = a);
    });
    n(this, "disposeEffect", () => this.cancel);
  }
  static create() {
    return new u();
  }
  static request(e) {
    return l.request(e);
  }
  static cancel(e) {
    return l.cancel(e);
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(e) {
    this.cancel(), this.currentId = l.request(() => {
      this.currentId = a, e();
    });
  }
}
function y() {
  const t = A(u.create).current;
  return g(t.disposeEffect), t;
}
function T(t, e = !1) {
  const s = y();
  return b((r, c = null) => {
    if (s.cancel(), t == null)
      return;
    let i;
    if ("current" in t) {
      if (t.current == null)
        return;
      i = t.current;
    } else
      i = t;
    typeof i.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED ? r() : s.request(() => {
      function o() {
        i && Promise.allSettled(i.getAnimations().map((f) => f.finished)).then(() => {
          c != null && c.aborted || S.flushSync(r);
        });
      }
      e ? s.request(o) : o();
    });
  });
}
export {
  u as A,
  d as T,
  y as a,
  x as t,
  T as u
};
